import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { CurrencyField, DateField, TextField } from '@roc/ui';
import { useStore } from '@roc/client-portal-shared/hooks';
import { formatDate, isNotBlank, parseDate } from '@roc/feature-utils';
// import { SpecialConditionsEditor } from '../specialConditions/specialConditionsEditor';

interface PurchaseContractFormContentProps {
  open: boolean;
}

export const PurchaseContractEditModal = observer(({ open }: PurchaseContractFormContentProps) => {
  const { docReviewStoreV2 } = useStore();
  const { purchaseContractFormStore } = docReviewStoreV2;

  useEffect(() => {
    if (open) purchaseContractFormStore.load(docReviewStoreV2.docReviewData);
  }, [open]);

  const handleChange = (field: string, value: any) => {
    purchaseContractFormStore.onFieldChange(field, value);
  };

  const f = purchaseContractFormStore.form.fields;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CurrencyField
          label="Acquisition Price"
          value={f.acquisitionPrice.value}
          onChange={(_name, value) => handleChange('acquisitionPrice', value)}
          name="acquisitionPrice"
          testId="acquisitionPrice"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.acquisitionPrice.error)}
          errorText={f.acquisitionPrice.error}
        />
      </Grid>
      <Grid item xs={12}>
        <DateField
          label="Acquisition Date"
          value={
            f.acquisitionDate.value ? parseDate(f.acquisitionDate.value) : null
          }
          onChange={value =>
            handleChange(
              'acquisitionDate',
              value ? formatDate(value, 'yyyy-MM-dd') : value
            )
          }
          error={isNotBlank(f.acquisitionDate.error)}
          errorText={f.acquisitionDate.error}
          format="MM/dd/yyyy"
          testId="acquisitionDate"
          inputVariant="outlined"
          fullWidth
          standaloneLabel
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Seller Name"
          value={f.sellerName.value}
          onChange={e => handleChange('sellerName', e.target.value)}
          name="sellerName"
          testId="sellerName"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.sellerName.error)}
          helperText={f.sellerName.error}
        />
      </Grid>
      <Grid item xs={12}>
        <CurrencyField
          label="Seller Credit"
          value={f.sellerCredit.value}
          onChange={(_name, value) => handleChange('sellerCredit', value)}
          name="sellerCredit"
          testId="sellerCredit"
          variant="outlined"
          fullWidth
          standaloneLabel
          error={isNotBlank(f.sellerCredit.error)}
          errorText={f.sellerCredit.error}
        />
      </Grid>
      {/*
        Special Conditions UI is parked pending business review of what the field
        should surface. The backend still extracts and stores specialConditions, so
        no data is lost while this is off - only the editing surface is disabled.
        Re-enable by uncommenting this and the import above, plus the matching
        blocks in the review table and purchaseContractFormStore.ts.

        <Grid item xs={12}>
          <SpecialConditionsEditor
            value={f.specialConditions.value}
            onChange={next => handleChange('specialConditions', next)}
          />
        </Grid>
      */}
    </Grid>
  );
});
